import { IDocument } from "./IDocument";
import { IShm } from "./IShm";
import { IVisitatieRapportGemeente } from "./IVisitatieRapportGemeente";
import { IVisitatieRapportVisitatieData } from "./IVisitatieRapportVisitatieDatum";
import { IVisitaiteRapportOperationeleDoelstelling } from "./VisitatieRapportOperationeleDoelstelling";

export enum VisitatieRapportActiviteitTypen {
    Huuractiviteiten, Koopactiviteiten
}

interface IVisitatieRapportBase {
    id: number;
    naam: string;
    shmId?: number;
    shm?: IShm;
    publicatieDatum?: Date;
    activiteit?: VisitatieRapportActiviteitTypen;
    visitatieRonde?: number;
    //gemeenten: number[];
    visitatieData: IVisitatieRapportVisitatieData[];
    documentId?: number;
    document?: IDocument;
    operationeleDoelstellingen: IVisitaiteRapportOperationeleDoelstelling[];
    gepubliceerd: boolean;
}

//dataview from server.
export interface IVisitatieRapportData extends IVisitatieRapportBase {
    gemeenten: IVisitatieRapportGemeente[];
}

//View in react
export interface IVisitatieRapport extends IVisitatieRapportBase {
    gemeenten: number[];
}

export const DefaultVisitatieRapport = (): IVisitatieRapport => ({
    id: 0,
    naam: "",
    //shmId: 0,
    //visitatieRonde: 0,
    gemeenten: [],
    visitatieData: [],
    operationeleDoelstellingen: [],
    publicatieDatum: new Date(),
    gepubliceerd: false
})